import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes, faTachometerAlt, faHdd, faHistory, faUsers, faBuilding, faSignOutAlt, faSignsPost } from '@fortawesome/free-solid-svg-icons';
import AuthContext from '../../AuthContext';

const Sidebar = () => {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const location = useLocation();
  const auth = useContext(AuthContext);
  //console.log(auth)

  useEffect(() => {
    //console.log('isMobileSidebarOpen:', isMobileSidebarOpen);
  }, [isMobileSidebarOpen]);

  useEffect(() => {
    if (isMobileSidebarOpen) {
      document.body.style.overflowX = 'hidden';
    } else {
      document.body.style.overflowX = 'auto';
    }
    return () => {
      document.body.style.overflowX = 'auto';
    };
  }, [isMobileSidebarOpen]);

  const toggleMobileSidebar = () => {
    //console.log('Toggling mobile sidebar');
    setIsMobileSidebarOpen(!isMobileSidebarOpen);
  };

  //console.log('Rendering Sidebar component');

  const handleLogout = () => {
    auth.signout();
    setIsMobileSidebarOpen(false); // Close the sidebar on mobile after logout
  };

  return (
    <>
      <div className="md:hidden flex items-center p-4">
        <FontAwesomeIcon
          icon={faBars}
          className="text-black text-2xl cursor-pointer"
          onClick={toggleMobileSidebar}
        />
      </div>

      <div
        className={`bg-white h-screen shadow-md flex flex-col p-4 items-center transition-transform duration-300
          md:w-[20vw] md:max-w-[15vw] md:flex md:fixed md:top-0 md:left-0 md:h-screen md:z-30
          sm:w-[40vw] sm:max-w-[40vw]
          ${
            isMobileSidebarOpen
              ? 'fixed inset-0 z-50 w-3/4 max-w-[300px] transform translate-x-0'
              : ' hidden'
          }`}
      >
        {isMobileSidebarOpen && (
          <div className="md:hidden flex justify-end w-full">
            <FontAwesomeIcon
              icon={faTimes}
              className="text-black text-xl cursor-pointer"
              onClick={toggleMobileSidebar}
            />
          </div>
        )}

        <h1 className="text-2xl font-bold mb-10 text-center">
          <span className="text-orange-500">An</span>
          <span className="text-black">tima</span>
        </h1>

        <div className="flex flex-col flex-1 justify-between w-full">
          <div className="flex flex-col gap-[10px]">
            <Link
              to="/"
              className={`pl-4 py-2 rounded-lg transition-colors duration-200 flex items-center space-x-2 ${
                location.pathname === '/'
                  ? 'bg-orange-500 text-white'
                  : 'text-gray-700 hover:bg-orange-100'
              }`}
              style={{
                fontFamily: 'Nunito Sans, sans-serif',
                fontSize: '14px',
                fontWeight: 600,
                color: location.pathname === '/' ? '#FFFFFF' : '#202224',
              }}
              onClick={() => setIsMobileSidebarOpen(false)}
            >
              <FontAwesomeIcon icon={faTachometerAlt} />
              <span>Dashboard</span>
            </Link>
            <Link
              to="/disk-erasure"
              className={`pl-4 py-2 rounded-lg transition-colors duration-200 flex items-center space-x-2 ${
                location.pathname === '/disk-erasure'
                  ? 'bg-orange-500 text-white'
                  : 'text-gray-700 hover:bg-orange-100'
              }`}
              style={{
                fontFamily: 'Nunito Sans, sans-serif',
                fontSize: '14px',
                fontWeight: 600,
                color: location.pathname === '/disk-erasure' ? '#FFFFFF' : '#202224',
              }}
              onClick={() => setIsMobileSidebarOpen(false)}
            >
              <FontAwesomeIcon icon={faHdd} />
              <span>Devices</span>
            </Link>
            <Link
              to="/activity-log"
              className={`pl-4 py-2 rounded-lg transition-colors duration-200 flex items-center space-x-2 ${
                location.pathname === '/activity-log'
                  ? 'bg-orange-500 text-white'
                  : 'text-gray-700 hover:bg-orange-100'
              }`}
              style={{
                fontFamily: 'Nunito Sans, sans-serif',
                fontSize: '14px',
                fontWeight: 600,
                color: location.pathname === '/activity-log' ? '#FFFFFF' : '#202224',
              }}
              onClick={() => setIsMobileSidebarOpen(false)}
            >
              <FontAwesomeIcon icon={faHistory} />
              <span>Activity Log</span>
            </Link>
            <div className="border-t mt-4 w-full"></div>
            <Link
              to="/users"
              className={`pl-4 py-2 rounded-lg transition-colors duration-200 flex items-center space-x-2 ${
                location.pathname === '/users'
                  ? 'bg-orange-500 text-white'
                  : 'text-gray-700 hover:bg-orange-100'
              }`}
              style={{
                fontFamily: 'Nunito Sans, sans-serif',
                fontSize: '14px',
                fontWeight: 600,
                color: location.pathname === '/users' ? '#FFFFFF' : '#202224',
              }}
              onClick={() => setIsMobileSidebarOpen(false)}
            >
              <FontAwesomeIcon icon={faUsers} />
              <span>Users</span>
            </Link>
           {auth.userType==='antima' &&(<>
            <Link
              to="/companies"
              className={`pl-4 py-2 rounded-lg transition-colors duration-200 flex items-center space-x-2 ${
                location.pathname === '/companies'
                  ? 'bg-orange-500 text-white'
                  : 'text-gray-700 hover:bg-orange-100'
              }`}
              style={{
                fontFamily: 'Nunito Sans, sans-serif',
                fontSize: '14px',
                fontWeight: 600,
                color: location.pathname === '/companies' ? '#FFFFFF' : '#202224',
              }}
              onClick={() => setIsMobileSidebarOpen(false)}
            >
              <FontAwesomeIcon icon={faBuilding} />
              <span>Companies</span>
            </Link>
           </>)}
            {auth.userType==='admin' &&(<>
            <Link
              to="/license"
              className={`pl-4 py-2 rounded-lg transition-colors duration-200 flex items-center space-x-2 ${
                location.pathname === '/companies'
                  ? 'bg-orange-500 text-white'
                  : 'text-gray-700 hover:bg-orange-100'
              }`}
              style={{
                fontFamily: 'Nunito Sans, sans-serif',
                fontSize: '14px',
                fontWeight: 600,
                color: location.pathname === '/companies' ? '#FFFFFF' : '#202224',
              }}
              onClick={() => setIsMobileSidebarOpen(false)}
            >
              <FontAwesomeIcon icon={faSignsPost} />
              <span>License</span>
            </Link>
           </>)}
            <Link
              to="/departments"
              className={`pl-4 py-2 rounded-lg transition-colors duration-200 flex items-center space-x-2 ${
                location.pathname === '/departments'
                  ? 'bg-orange-500 text-white'
                  : 'text-gray-700 hover:bg-orange-100'
              }`}
              style={{
                fontFamily: 'Nunito Sans, sans-serif',
                fontSize: '14px',
                fontWeight: 600,
                color: location.pathname === '/departments' ? '#FFFFFF' : '#202224',
              }}
              onClick={() => setIsMobileSidebarOpen(false)}
            >
              <FontAwesomeIcon icon={faBuilding} />
              <span>Departments</span>
            </Link>
            <div
              className="pl-4 py-2 rounded-lg transition-colors duration-200 flex items-center space-x-2 text-gray-700 hover:bg-orange-100 cursor-pointer"
              style={{
                fontFamily: 'Nunito Sans, sans-serif',
                fontSize: '14px',
                fontWeight: 600,
                color: '#202224',
              }}
              onClick={handleLogout}
            >
              <FontAwesomeIcon icon={faSignOutAlt} />
              <span>Logout</span>
            </div>
          </div>
        </div>

        <div className="border-t mt-8 w-full"></div>
      </div>

      {isMobileSidebarOpen && (
        <div
          className="md:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={toggleMobileSidebar}
        ></div>
      )}
    </>
  );
};

export default Sidebar;